import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const Heading = ({ title, className }: { title: string; className?: string }) => {
  return <HtmlRendererRaw className={cn('ea-heading', className)} html={title} />;
};
